import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	servicesTitle: {
		id: 'servicedesk-itsm-features.app.sections.service-project-section.dev-ops-features.services-title',
		defaultMessage: 'Services',
		description: 'Title text of the services setting',
	},
	servicesDescription: {
		id: 'servicedesk-itsm-features.app.sections.service-project-section.dev-ops-features.services-description',
		defaultMessage:
			'Services hold details of the products and applications your organization uses. These can be used for a variety of features, including approving changes or knowing who to alert of an incident. {learnMoreLink}.',
		description: 'Description that explains the affects of services setting',
	},
	servicesLink: {
		id: 'servicedesk-itsm-features.app.sections.service-project-section.dev-ops-features.services-link',
		defaultMessage: 'Learn more about Services',
		description: 'Text used in services learn more link',
	},
	alertsTitle: {
		id: 'servicedesk-itsm-features.app.sections.service-project-section.dev-ops-features.alerts-title',
		defaultMessage: 'Alerts',
		description: 'Title text of the alerts setting',
	},
	alertsDescription: {
		id: 'servicedesk-itsm-features.app.sections.service-project-section.dev-ops-features.alerts-description',
		defaultMessage:
			'Give access to {opsgenieLink} in this project to let your team notify the right people of incidents as they happen. {learnMoreLink}.',
		description: 'Description that explains the affects of alerts setting',
	},
	alertsOgLink: {
		id: 'servicedesk-itsm-features.app.sections.service-project-section.dev-ops-features.alerts-og-link',
		defaultMessage: 'Alerts by Opsgenie',
		description: 'Text used in link to Opsgenie alerts page',
	},
	alertsLink: {
		id: 'servicedesk-itsm-features.app.sections.service-project-section.dev-ops-features.alerts-link',
		defaultMessage: 'Learn more about Alerts',
		description: 'Text used in alerts learn more link',
	},
	alertsConsolidatedDescription: {
		id: 'servicedesk-itsm-features.app.sections.service-project-section.dev-ops-features.alerts-consolidated-description',
		defaultMessage:
			'Give access to Alerts in this project to notify the right people during incidents and provide more context by linking alerts to incidents. {learnMoreLink}.',
		description: 'Description that explains the affects of alerts setting for consolidated view',
	},
	alertsLinkConsolidated: {
		id: 'servicedesk-itsm-features.app.sections.service-project-section.dev-ops-features.alerts-link-consolidated',
		defaultMessage: 'Read more about alerts',
		description: 'Text used for alerts learn more link for consolidated view',
	},
	oncallTitle: {
		id: 'servicedesk-itsm-features.app.sections.service-project-section.dev-ops-features.oncall-title',
		defaultMessage: 'On-call',
		description: 'Title text of the oncall setting',
	},
	oncallDescription: {
		id: 'servicedesk-itsm-features.app.sections.service-project-section.dev-ops-features.oncall-description',
		defaultMessage:
			"Give access to {opsgenieLink} in this project to let your team see who's rostered to be alerted about incidents. {learnMoreLink}.",
		description: 'Description that explains the affects of oncall setting',
	},
	oncallConsolidatedDescription: {
		id: 'servicedesk-itsm-features.app.sections.service-project-section.dev-ops-features.oncall-consolidated-description',
		defaultMessage:
			'Give access to On-call in this project to let your team see who is on call and notified about incidents. {learnMoreLink}.',
		description: 'Description that explains the affects of oncall setting for consolidated view',
	},
	oncallLinkConsolidated: {
		id: 'servicedesk-itsm-features.app.sections.service-project-section.dev-ops-features.oncall-link-consolidated',
		defaultMessage: 'Read more about on-call schedules',
		description: 'Text used in oncall learn more link for consolidated view',
	},
	oncallOgLink: {
		id: 'servicedesk-itsm-features.app.sections.service-project-section.dev-ops-features.oncall-og-link',
		defaultMessage: 'On-call by Opsgenie',
		description: 'Text used in link to Opsgenie oc-call page',
	},
	oncallLink: {
		id: 'servicedesk-itsm-features.app.sections.service-project-section.dev-ops-features.oncall-link',
		defaultMessage: 'Learn more about On-call',
		description: 'Text used in oncall learn more link',
	},
});
